import React from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import * as Page from '../Pages';
import PublicMapView from '../Pages/PublicMapView';
import PrivateRoute from './PrivateRoute';

const Routes = () => {
  // Verifica se a rota atual é uma rota pública
  const isPublicRoute = () => {
    const path = window.location.pathname;
    return path.startsWith('/public/') || path === '/Menu/Analytics/Mapas';
  };

  return (
    <BrowserRouter>
      <div style={{height:"100%"}}>
        <div style={{width:"100%", height:"70px", margin:"0", padding:"0"}}>
          {!isPublicRoute() && <Page.TopBar />}
        </div>
        <div style={{display:"flex", padding:"0", width:"100%", height:"calc(100% - 70px)"}}>
          {!isPublicRoute() && <Page.SideBar />}
          <Switch>
            {/* Rota pública para visualização de mapas */}
            <Route path="/public/map" component={PublicMapView} />
            <Route path="/public/map/:token" component={PublicMapView} />

            {/* Rotas públicas de autenticação */}
            <Route path="/" exact component={Page.SignIn} />
            <Route path="/ForgotPassword" exact component={Page.ForgotPassword} />
            <Route path="/ResetPassword" exact component={Page.ResetPassword} />
            <Route path="/PasswordReset/:Token" exact component={Page.PasswordReset} />
            <Route path="/SignUp" exact component={Page.SignUp} />
            <Route path="/UserApproved" exact component={Page.UserApproved} />
            
            {/* Rotas protegidas que precisam de autenticação */}
            <PrivateRoute path="/AcompanhamentoDeSala" exact component={Page.AcompanhamentoDeSala} />
            <PrivateRoute path="/Bordero" exact component={Page.Bordero} />
            <PrivateRoute path="/CategoriasReserva" exact component={Page.CategoriasDeReserva} />
            <PrivateRoute path="/Disponibilidade" exact component={Page.Disponibilidade} />
            <PrivateRoute path="/DeParaCNAEs" exact component={Page.DeParaCNAEs} />
            <PrivateRoute path="/PivotTable" exact component={Page.PivotTable} />
            <PrivateRoute path="/Gerador" exact component={Page.Gerador} />
            <PrivateRoute path="/VendaDireta" exact component={Page.VendaDireta} />
            <PrivateRoute path="/Menu" exact component={Page.Menu} />
            <Route path="/Menu/Analytics/Mapas" exact component={Page.Mapas} />
            <PrivateRoute path="/MeusContratos" exact component={Page.MeusContratos} />
            <PrivateRoute path="/NFSe" exact component={Page.NFSe} />
            <PrivateRoute path="/PropostasPendentes" exact component={Page.PropostasPendentes} />
            <PrivateRoute path="/Menu/Analytics" exact component={Page.Analytics} />
            <PrivateRoute path="/Menu/Analytics/Resumo" exact component={Page.Analytics} />
            <PrivateRoute path="/Menu/Analytics/Vendas" exact component={Page.Analytics} />
            <PrivateRoute path="/Menu/Analytics/Cessao" exact component={Page.Analytics} />
            <PrivateRoute path="/Menu/Analytics/Distratos" exact component={Page.Analytics} />
            <PrivateRoute path="/Menu/Analytics/Depositos" exact component={Page.Analytics} />
            <PrivateRoute path="/Menu/Analytics/VendaNoTempo" exact component={Page.Analytics} />
            <PrivateRoute path="/Menu/Analytics/Carteira" exact component={Page.Analytics} />
            <PrivateRoute path="/Menu/Analytics/Fluxo" exact component={Page.Analytics} />
            <PrivateRoute path="/Menu/Analytics/Planejamento" exact component={Page.Analytics} />
            <PrivateRoute path="/Menu/Analytics/Realizar" exact component={Page.Analytics} />
            <PrivateRoute path="/Menu/Analytics/Desembolso" exact component={Page.Analytics} />
            <PrivateRoute path="/ConfigDePara" exact component={Page.ConfigDePara} />
            <PrivateRoute path="/Menu/Analytics/Financeiro" exact component={Page.Analytics} />
            <PrivateRoute path="/Users" exact component={Page.Users} />
            <PrivateRoute path="/Menu/Analytics/ResumoCarteira" exact component={Page.Analytics} />
            
            {/* Rota padrão para redirecionar URLs desconhecidos */}
            <Route path="*" component={() => {
              window.location.href = '/';
              return null;
            }} />
          </Switch>
        </div>
      </div>
    </BrowserRouter>
  );
};

export default Routes;
